// extracted by mini-css-extract-plugin
export default {"content":"content_qeoBS","inFeed":"inFeed_U8Iwi","desc":"desc_yGzuR","ellipsis":"ellipsis_bPgvm","link":"link_isFW4","icon":"icon_kRc3k"};